import { render, staticRenderFns } from "./OpenEndWriting.vue.js?vue&type=template&id=5b140dcf&scoped=true!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./OpenEndWriting.vue?vue&type=template&id=5b140dcf&scoped=true"
import script from "./OpenEndWriting.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./OpenEndWriting.vue?vue&type=script&lang=js"
export * from "./OpenEndWriting.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./OpenEndWriting.vue?vue&type=script&lang=js"
import style0 from "./OpenEndWriting.vue.css?vue&type=style&index=0&id=5b140dcf&prod&scoped=true&lang=css!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./OpenEndWriting.vue?vue&type=style&index=0&id=5b140dcf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b140dcf",
  null
  
)

export default component.exports